import { render, staticRenderFns } from "./Threepartyfreight.vue?vue&type=template&id=0deb2c72&scoped=true"
import script from "./Threepartyfreight.vue?vue&type=script&lang=js"
export * from "./Threepartyfreight.vue?vue&type=script&lang=js"
import style0 from "./Threepartyfreight.vue?vue&type=style&index=0&id=0deb2c72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0deb2c72",
  null
  
)

export default component.exports